import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

type LoaderContextType = {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const LoadingContext = createContext<LoaderContextType | undefined>(undefined);

const timeout = (delay: number) => {
  return new Promise((res) => setTimeout(res, delay));
};

const callTimeout = async () => {
  await timeout(500000); // Consider reducing this
};

type LoadingProviderProps = {
  children: ReactNode;
};

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!loading) {
      callTimeout(); // Runs once when loading is false
    }
  }, [loading]);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {loading && (
        <div className="loader">
          <div className="loading-container">
            <div className="cube">
              <div className="sides">
                <div className="top"></div>
                <div className="right"></div>
                <div className="bottom"></div>
                <div className="left"></div>
                <div className="front"></div>
                <div className="back"></div>
              </div>
            </div>
            {/* <div className="text">BUNDLING DEPENDENCIES</div> */}
          </div>
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};
